(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Fraction of velocity still remaining after 1 second when easing toward a
    // target speed. Smaller = snappier; this gives a gentle ~1s ease in/out.
    var EASE_REMAIN = 0.04;
    var DRAG_THRESHOLD = 6; // px before a press counts as a drag (vs a click)

    function initMarquee(root) {
      if (root.dataset.marqueeReady) return;
      var track = root.querySelector('.featured-products__track');
      if (!track) return;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return; // leave the native swipe/scroll fallback in place
      }
      root.dataset.marqueeReady = '1';

      // Take over from the CSS animation.
      track.style.animation = 'none';

      var duration = parseFloat(root.getAttribute('data-duration')) || 60;
      var copyWidth = track.scrollWidth / 2;

      var offset = 0;       // current translateX in px (<= 0 while scrolling left)
      var velocity = 0;     // px/sec, signed (negative = leftward)
      var hovering = false;
      var dragging = false;
      var dragMoved = false;
      var startX = 0, startOffset = 0, lastX = 0, lastT = 0, dragVel = 0;
      var lastFrame = null;

      function measure() {
        var w = track.scrollWidth / 2;
        if (w > 0) copyWidth = w;
      }
      function baseSpeed() {
        return -(copyWidth / duration); // leftward
      }
      function wrap() {
        if (copyWidth <= 0) return;
        offset = offset % copyWidth;
        if (offset > 0) offset -= copyWidth;
      }
      function apply() {
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function frame(now) {
        if (lastFrame === null) lastFrame = now;
        var dt = (now - lastFrame) / 1000;
        lastFrame = now;
        if (dt > 0.05) dt = 0.05; // clamp after tab-switch/jank

        if (!dragging) {
          var target = hovering ? 0 : baseSpeed();
          var factor = 1 - Math.pow(EASE_REMAIN, dt);
          velocity += (target - velocity) * factor;
          offset += velocity * dt;
          wrap();
          apply();
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      root.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') hovering = true;
      });
      root.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') hovering = false;
      });

      root.addEventListener('pointerdown', function (e) {
        if (typeof e.button === 'number' && e.button !== 0) return;
        dragging = true;
        dragMoved = false;
        startX = e.clientX;
        startOffset = offset;
        lastX = e.clientX;
        lastT = e.timeStamp;
        dragVel = 0;
        root.classList.add('is-dragging');
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
      });

      root.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) dragMoved = true;
        offset = startOffset + dx;
        wrap();
        apply();
        var dtm = (e.timeStamp - lastT) / 1000;
        if (dtm > 0) dragVel = (e.clientX - lastX) / dtm; // px/sec
        lastX = e.clientX;
        lastT = e.timeStamp;
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        velocity = dragVel; // momentum, then eases back toward auto-scroll
        lastFrame = null;
      }
      root.addEventListener('pointerup', endDrag);
      root.addEventListener('pointercancel', endDrag);

      // Swallow the click that ends a drag so it doesn't navigate to a product.
      root.addEventListener('click', function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measure, 150);
      });
      window.addEventListener('load', measure);
      measure();
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-marquee]');
      for (var i = 0; i < nodes.length; i++) initMarquee(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      this.dropdownToggles = this.querySelectorAll('[data-dropdown-toggle]');
      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.mobileMenu = this.querySelector('[data-mobile-menu]');
      this.cartToggle = this.querySelector('[data-cart-toggle]');

      this.dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          const item = toggle.closest('.header__nav-item--dropdown');
          const isOpen = item.hasAttribute('data-open');
          this.closeAllDropdowns();
          if (!isOpen) {
            item.setAttribute('data-open', '');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', () => this.closeAllDropdowns());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openItem = this.querySelector('.header__nav-item--dropdown[data-open]');
          if (openItem) {
            this.closeAllDropdowns();
            const btn = openItem.querySelector('[data-dropdown-toggle]');
            if (btn) btn.focus();
          }
        }
      });

      if (this.mobileToggle && this.mobileMenu) {
        this.mobileToggle.addEventListener('click', () => {
          if (this.mobileMenu.classList.contains('is-open')) {
            this.closeMobileMenu();
          } else {
            this.openMobileMenu();
          }
        });

        // While open: Escape closes, and Tab is trapped within the menu.
        this.mobileMenu.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeMobileMenu();
            return;
          }
          if (e.key !== 'Tab') return;
          const focusable = Array.from(this.mobileMenu.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          )).filter((el) => el.getClientRects().length > 0);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
      }

      if (this.cartToggle) {
        this.cartToggle.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      }

      const searchToggle = this.querySelector('[data-predictive-toggle]');
      const predictiveSearch = this.querySelector('predictive-search');
      if (searchToggle && predictiveSearch) {
        searchToggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (predictiveSearch.hidden) {
            predictiveSearch.show();
          } else {
            predictiveSearch.hide();
          }
        });
      }

      if (this.hasAttribute('data-overlay')) {
        const announcement = document.querySelector('.announcement-bar');
        const syncTop = () => {
          const h = announcement ? announcement.getBoundingClientRect().bottom : 0;
          this.style.top = Math.max(0, h) + 'px';
        };
        const onScroll = () => {
          this.classList.toggle('is-scrolled', window.scrollY > 10);
          syncTop();
        };
        syncTop();
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', syncTop);
      }
    }

    closeAllDropdowns() {
      this.querySelectorAll('.header__nav-item--dropdown[data-open]').forEach(item => {
        item.removeAttribute('data-open');
        const btn = item.querySelector('[data-dropdown-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    openMobileMenu() {
      this.mobileMenu.classList.add('is-open');
      this.mobileToggle.setAttribute('aria-expanded', 'true');
      const first = this.mobileMenu.querySelector('a[href], button:not([disabled]), input:not([disabled])');
      if (first) first.focus();
    }

    closeMobileMenu() {
      this.mobileMenu.classList.remove('is-open');
      this.mobileToggle.setAttribute('aria-expanded', 'false');
      this.mobileToggle.focus();
    }
  }
  customElements.define('header-nav', HeaderNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class MainCart extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
      const removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        this.changeLine(removeBtn.dataset.lineKey, 0);
        return;
      }

      const qtyBtn = e.target.closest('[data-qty-btn]');
      if (qtyBtn) {
        e.preventDefault();
        const row = qtyBtn.closest('.cart-page__item-quantity');
        const countEl = row ? row.querySelector('[data-qty-count]') : null;
        const current = countEl ? (parseInt(countEl.textContent, 10) || 0) : 0;
        const delta = parseInt(qtyBtn.dataset.qtyDelta, 10) || 0;
        const next = current + delta;
        if (next < 0) return;
        this.changeLine(qtyBtn.dataset.lineKey, next);
      }
    }

    async changeLine(key, quantity) {
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!r.ok) throw new Error('cart change failed');
        await this.refresh();
      } catch (err) {
        window.location.reload();
      }
    }

    async refresh() {
      const r = await fetch(`${window.location.pathname}?section_id=main-cart`);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('main-cart');
      if (fresh) {
        this.innerHTML = fresh.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }
  if (!customElements.get('main-cart')) {
    customElements.define('main-cart', MainCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionFacets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      this.sort = this.querySelector('[data-sort-by]');
      this.openBtn = this.querySelector('[data-facets-open]');
      this.closeBtn = this.querySelector('[data-facets-close]');
      this.overlay = this.querySelector('[data-facets-overlay]');

      if (this.form) {
        this.form.addEventListener('input', (e) => {
          if (e.target.matches('input[type="checkbox"]')) {
            if (!this.isMobile()) this.submit();
          }
        });
        this.form.addEventListener('change', (e) => {
          if (e.target.matches('input[type="number"]')) {
            if (!this.isMobile()) this.submit();
          }
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submit();
        });
      }

      if (this.sort) {
        this.sort.addEventListener('change', () => {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', this.sort.value);
          params.delete('page');
          window.location.search = params.toString();
        });
      }

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.openDrawer());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeDrawer());
      if (this.overlay) this.overlay.addEventListener('click', () => this.closeDrawer());
    }

    isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    submit() {
      const data = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of data.entries()) {
        if (v !== '') params.append(k, v);
      }
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      const base = window.location.pathname;
      window.location.href = params.toString() ? `${base}?${params.toString()}` : base;
    }

    openDrawer() {
      this.setAttribute('data-facets-open', '');
      document.body.classList.add('facets-open');
    }
    closeDrawer() {
      this.removeAttribute('data-facets-open');
      document.body.classList.remove('facets-open');
    }
  }
  customElements.define('collection-facets', CollectionFacets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-add-form]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-product-price]');
      this.addBtn = this.querySelector('[data-add-to-cart]');
      this.addBtnText = this.querySelector('[data-add-to-cart-text]');
      this.mainImageEl = this.querySelector('[data-main-image]');
      this.stockEl = this.querySelector('[data-stock-indicator]');
      this.specialOrderEl = this.querySelector('[data-special-order]');
      this.specialOrderNoteEl = this.querySelector('[data-special-order-note]');
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.counterCurrent = this.querySelector('[data-gallery-current]');
      this.currentImageIndex = 0;
      this.currency = this.dataset.currency || 'CAD';
      this.locale = this.dataset.locale || 'en-CA';
      this.productTitle = this.dataset.productTitle || '';
      this.addLabel = this.addBtn ? this.addBtn.dataset.addLabel : '';
      this.soldLabel = this.addBtn ? this.addBtn.dataset.soldLabel : '';
      this.chooseLabel = this.addBtn ? this.addBtn.dataset.chooseLabel : '';
      this.acceleratedEl = this.querySelector('[data-accelerated]');
      this.currentAvailable = this.addBtn ? !this.addBtn.disabled : true;
      this.statusEl = this.querySelector('[data-add-status]');
      this.addedMessage = this.dataset.addedMessage || '';
      this.unavailableLabel = this.dataset.unavailableLabel || 'Unavailable';
      this.lowStockLabel = this.dataset.lowStockLabel || '';
      this.addErrorLabel = this.dataset.addErrorLabel || '';

      this.pickupContainer = this.querySelector('[data-pickup-availability]');
      this.pickupUrl = this.dataset.pickupUrl || '';
      this.pickupCache = {};
      this.pickupController = null;
      if (this.pickupContainer && this.variantIdInput) {
        const seed = this.pickupContainer.querySelector('[data-pickup-content]');
        this.pickupCache[this.variantIdInput.value] = seed ? seed.outerHTML : '';
      }

      try {
        this.variants = JSON.parse(this.querySelector('[data-product-json]').textContent);
      } catch(e) {
        this.variants = [];
      }

      try {
        this.stockMap = JSON.parse(this.querySelector('[data-product-stock-map]').textContent);
      } catch(e) {
        this.stockMap = {};
      }

      this.optionInputs = this.querySelectorAll('[data-option-input]');
      this.hasOptions = this.optionInputs.length > 0;
      this.optionCount = (this.variants[0] && this.variants[0].options) ? this.variants[0].options.length : 0;
      this.optionInputs.forEach(input => {
        input.addEventListener('change', () => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          this.onVariantChange({ changedIndex: isNaN(idx) ? null : idx });
        });
      });

      this.thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.setImage(index));
        // Preload this image's full-size version on intent, so the click swap is instant.
        const warmThumb = () => this.warmImage(thumb.dataset.imageUrl);
        thumb.addEventListener('pointerenter', warmThumb, { once: true });
        thumb.addEventListener('focus', warmThumb, { once: true });
      });

      const initialSrc = this.mainImageEl?.querySelector('img')?.src;
      const initialIndex = this.findImageIndex(initialSrc);
      if (initialIndex >= 0) this.syncGalleryState(initialIndex);

      this.querySelectorAll('[data-gallery-dot]').forEach(dot => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.imageIndex, 10);
          const thumbs = this.querySelectorAll('[data-thumbnail]');
          if (thumbs[idx]) thumbs[idx].click();
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          const total = this.thumbnails.length;
          if (!total) return;
          this.setImage((this.currentImageIndex - 1 + total) % total);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          const total = this.thumbnails.length;
          if (!total) return;
          this.setImage((this.currentImageIndex + 1) % total);
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', (e) => this.onFormSubmit(e));
      }

      this.setupStickyBar();
      this.setupNotify();

      const decBtn = this.querySelector('[data-qty-decrement]');
      const incBtn = this.querySelector('[data-qty-increment]');
      const qtyInput = this.querySelector('[data-qty-input]');
      if (decBtn && incBtn && qtyInput) {
        const max = qtyInput.getAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : Infinity;
        const updateDecState = () => {
          const v = parseInt(qtyInput.value, 10) || 1;
          decBtn.disabled = v <= 1;
          incBtn.disabled = v >= max;
        };
        decBtn.addEventListener('click', () => {
          const v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
          updateDecState();
        });
        incBtn.addEventListener('click', () => {
          const v = parseInt(qtyInput.value, 10) || 1;
          if (v < max) qtyInput.value = v + 1;
          updateDecState();
        });
        qtyInput.addEventListener('input', () => {
          let v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 1) qtyInput.value = 1;
          else if (v > max) qtyInput.value = max;
          updateDecState();
        });
        updateDecState();
      }

      // Establish the initial control state. Liquid has already rendered the preselected
      // variant's price, label and chips, so this pass only has to agree with it. It is
      // flagged initial so it does not pull the gallery off the product's first image.
      if (this.hasOptions) {
        this.onVariantChange({ initial: true });
      } else {
        this.updateOptionAvailability();
      }
      this.preloadGalleryImages();
    }

    // Sticky mobile Add to cart (RET-160). Liquid only renders the bar on products with
    // more than 8 option chips, and CSS only shows it under 750px. It submits the main form,
    // so the variant, quantity and add flow are the main button's own. It shows while the
    // main Add to cart row is off screen, and steps aside once the footer comes into view.
    setupStickyBar() {
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      if (!this.stickyBar) return;
      this.stickyVariant = this.stickyBar.querySelector('[data-sticky-variant]');
      this.stickyCurrent = this.stickyBar.querySelector('[data-sticky-price-current]');
      this.stickyCompare = this.stickyBar.querySelector('[data-sticky-price-compare]');
      this.stickyBtn = this.stickyBar.querySelector('[data-sticky-add]');
      this.stickyBtnText = this.stickyBar.querySelector('[data-sticky-add-text]');

      const addRow = this.querySelector('.product-page__add-row');
      const footer = document.getElementById('shopify-section-footer');
      if (!addRow || !('IntersectionObserver' in window)) return;

      let addRowOnScreen = true;
      let footerOnScreen = false;
      const update = () => {
        this.stickyBar.classList.toggle('is-visible', !addRowOnScreen && !footerOnScreen);
      };
      new IntersectionObserver(([entry]) => {
        addRowOnScreen = entry.isIntersecting;
        update();
      }).observe(addRow);
      if (footer) {
        new IntersectionObserver(([entry]) => {
          footerOnScreen = entry.isIntersecting;
          update();
        }).observe(footer);
      }
    }

    // Notify me (RET-158). The form shows only while the selected variant is sold out, and its
    // tag names that variant, so the back in stock flow (RET-183) knows who wants what.
    setupNotify() {
      this.notifyEl = this.querySelector('[data-notify]');
      if (!this.notifyEl) return;
      this.notifyForm = this.notifyEl.querySelector('[data-notify-form]');
      this.notifyTags = this.notifyEl.querySelector('[data-notify-tags]');
      this.notifySuccess = this.notifyEl.querySelector('[data-notify-success]');

      // Back from a successful post: customer_posted=true plus this form's anchor. The anchor
      // matters because the footer signup is a customer form too. Reselect the remembered
      // option before the first variant pass runs, show the thank you, keep it through that
      // pass, and drop the flag so a refresh starts clean.
      if (window.location.hash === '#product-notify-form' && /[?&]customer_posted=true/.test(window.location.search)) {
        let rememberedId = null;
        try {
          rememberedId = sessionStorage.getItem('notify-me-variant');
          sessionStorage.removeItem('notify-me-variant');
        } catch (e) {}
        const remembered = rememberedId && this.variants.find(v => String(v.id) === rememberedId);
        if (remembered && this.hasOptions) {
          this.syncOptionInputs(remembered.options);
          this.setAttribute('data-variant-deeplinked', '');
        }
        this.notifyPostedBack = true;
        this.notifyEl.hidden = false;
        this.notifyForm.hidden = true;
        this.notifySuccess.hidden = false;
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        history.replaceState(history.state, '', url);
        requestAnimationFrame(() => this.notifyEl.scrollIntoView({ block: 'center' }));
      }
    }

    updateNotify(variant) {
      if (!this.notifyEl) return;
      if (this.notifyPostedBack) {
        this.notifyPostedBack = false;
        return;
      }
      const soldOut = !!variant && !variant.available;
      this.notifyEl.hidden = !soldOut;
      if (!soldOut) return;
      this.notifyTags.value = 'notify-me,notify-me-' + variant.id;
      this.notifyForm.hidden = false;
      this.notifySuccess.hidden = true;
      // The post reloads the page, and Shopify sends the shopper back without their option
      // choice. Remember the variant the form now names (the store's spam check owns the
      // submit event, so this is the reliable moment), and setupNotify reselects it.
      try {
        sessionStorage.setItem('notify-me-variant', String(variant.id));
      } catch (e) {}
    }

    // Mirror the main price block and button, which onVariantChange has just set, so the
    // bar can never disagree with the page.
    syncStickyBar(variant) {
      if (!this.stickyBar) return;
      const mainCurrent = this.priceEl ? this.priceEl.querySelector('[data-price-current]') : null;
      const mainCompare = this.priceEl ? this.priceEl.querySelector('[data-price-compare]') : null;
      if (this.stickyVariant) this.stickyVariant.textContent = variant ? variant.options.join(' / ') : '';
      if (this.stickyCurrent && mainCurrent) {
        this.stickyCurrent.textContent = mainCurrent.textContent;
        this.stickyCurrent.classList.toggle('sticky-atc__price-current--sale', mainCurrent.classList.contains('product-page__price-current--sale'));
      }
      if (this.stickyCompare && mainCompare) {
        this.stickyCompare.textContent = mainCompare.textContent;
        this.stickyCompare.hidden = mainCompare.hidden;
      }
      if (this.stickyBtn && this.addBtn) {
        this.stickyBtn.disabled = this.addBtn.disabled;
        if (this.stickyBtnText && this.addBtnText) this.stickyBtnText.textContent = this.addBtnText.textContent;
      }
    }

    getSelectedOptions() {
      const selected = new Array(this.optionCount).fill(null);
      this.optionInputs.forEach(input => {
        if (input.checked) {
          const idx = parseInt(input.dataset.optionIndex, 10);
          if (!isNaN(idx)) selected[idx] = input.value;
        }
      });
      return selected;
    }

    setIncompleteState() {
      if (this.variantIdInput) this.variantIdInput.value = '';
      this.currentAvailable = false;
      if (this.addBtn) {
        this.addBtn.disabled = true;
        if (this.addBtnText) this.addBtnText.textContent = this.chooseLabel;
      }
      if (this.acceleratedEl) this.acceleratedEl.hidden = true;
      if (this.pickupContainer) this.pickupContainer.hidden = true;
      this.updateNotify(null);
      if (this.stockEl) {
        this.stockEl.textContent = '';
        this.stockEl.hidden = true;
      }
      if (this.specialOrderEl) this.specialOrderEl.hidden = true;
    }

    setImage(index) {
      const thumb = this.thumbnails[index];
      if (!thumb) return;
      const url = thumb.dataset.imageUrl;
      const alt = thumb.dataset.imageAlt;
      const img = this.mainImageEl.querySelector('img');
      if (img && url) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
        img.alt = alt || this.productTitle || '';
      }
      this.syncGalleryState(index);
    }

    syncGalleryState(index) {
      this.thumbnails.forEach((t, i) => t.classList.toggle('is-active', i === index));
      this.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
      this.currentImageIndex = index;
      if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
    }

    warmImage(url) {
      if (!url) return;
      if (!this._warmed) this._warmed = new Set();
      if (this._warmed.has(url)) return;
      this._warmed.add(url);
      const img = new Image();
      img.src = url;
    }

    preloadGalleryImages() {
      if (!this.thumbnails || this.thumbnails.length < 2) return;
      // Thumbnails only load tiny (80-240px) images, but a click swaps the main image
      // to the full-size (1120px) version. Warm those into cache after the page has
      // loaded (so we never compete with the main image / LCP), making the swap instant.
      const warmAll = () => this.thumbnails.forEach((t) => this.warmImage(t.dataset.imageUrl));
      const schedule = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(warmAll, { timeout: 1500 });
        } else {
          setTimeout(warmAll, 300);
        }
      };
      if (document.readyState === 'complete') {
        schedule();
      } else {
        window.addEventListener('load', schedule, { once: true });
      }
    }

    findImageIndex(src) {
      if (!src) return -1;
      const normalize = (u) => (u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*\.|_\d+x\.|_\d+x_/g, '_');
      const target = normalize(src);
      return this.thumbnails.findIndex(t => normalize(t.dataset.imageUrl) === target);
    }

    // Find the variant for a chosen set of options, repairing combinations that do not
    // exist. changedIndex is the option the shopper just touched: that choice is honoured
    // and the OTHER options move to meet it, so clicking a colour that this size does not
    // come in switches the size rather than killing the button. Returns the option array
    // actually used, which may differ from the one passed in.
    resolveVariant(selected, changedIndex) {
      // The combination exists: use it, in stock or not. A sold out combination stays
      // selected and the button says Sold out, so the shopper's other choices never move
      // without them asking. Repairing a sold out combination switched the size when a
      // shopper changed colour, with no notice (RET-154 QA, 2026-09-23).
      const exact = this.variants.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (exact) return { variant: exact, options: selected };

      // The combination does not exist in the catalogue at all. Honour the value the shopper
      // just clicked and move the OTHER options to the nearest variant that carries it,
      // preferring one in stock.
      if (changedIndex != null && selected[changedIndex] != null) {
        const carriesChoice = this.variants.filter(v => v.options[changedIndex] === selected[changedIndex]);
        const pick = this.closestVariant(carriesChoice.filter(v => v.available), selected) || this.closestVariant(carriesChoice, selected);
        if (pick) return { variant: pick, options: pick.options.slice() };
      }

      const fallback = this.variants.find(v => v.available) || this.variants[0];
      if (fallback) return { variant: fallback, options: fallback.options.slice() };
      return { variant: null, options: selected };
    }

    // The candidate that keeps the most of the shopper's other choices, so repairing one
    // option group does not reset the rest. Ties go to catalogue order.
    closestVariant(candidates, selected) {
      let best = null;
      let bestScore = -1;
      candidates.forEach((v) => {
        const score = v.options.reduce((n, opt, i) => n + (opt === selected[i] ? 1 : 0), 0);
        if (score > bestScore) {
          best = v;
          bestScore = score;
        }
      });
      return best;
    }

    syncOptionInputs(options) {
      this.optionInputs.forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        if (isNaN(idx)) return;
        input.checked = options[idx] === input.value;
      });
    }

    onVariantChange(opts) {
      const settings = opts || {};
      const resolved = this.resolveVariant(this.getSelectedOptions(), settings.changedIndex != null ? settings.changedIndex : null);
      const variant = resolved.variant;

      // Repairing a combination moves other option groups, so push the result back into
      // the radios before the chips are restyled from them.
      this.syncOptionInputs(resolved.options);

      this.querySelectorAll('.variant-btn').forEach(label => {
        const input = this.querySelector('#' + label.getAttribute('for'));
        if (input && input.checked) {
          label.classList.add('is-selected');
        } else {
          label.classList.remove('is-selected');
        }
      });

      // Only reachable when the product has no variants at all.
      if (!variant) {
        this.setIncompleteState();
        this.updateOptionAvailability();
        this.syncStickyBar(null);
        return;
      }

      if (this.acceleratedEl) this.acceleratedEl.hidden = !variant.available;
      if (this.pickupContainer) this.pickupContainer.hidden = false;

      // Preselection must not drag the hero image with it. On the first pass only an
      // explicit ?variant= deep-link may move the gallery (23e3278); shopper clicks after
      // that always may.
      const mayMoveGallery = !settings.initial || this.hasAttribute('data-variant-deeplinked');

      {
        this.variantIdInput.value = variant.id;
        const fmt = (cents) => {
          const amount = cents / 100;
          try {
            return amount.toLocaleString(this.locale, { style: 'currency', currency: this.currency, currencyDisplay: 'narrowSymbol' });
          } catch (e) {
            return amount.toLocaleString(this.locale, { style: 'currency', currency: this.currency });
          }
        };
        const currentEl = this.priceEl ? this.priceEl.querySelector('[data-price-current]') : null;
        const compareEl = this.priceEl ? this.priceEl.querySelector('[data-price-compare]') : null;
        if (currentEl) currentEl.textContent = fmt(variant.price);
        const pointsEl = this.querySelector('[data-points-amount]');
        if (pointsEl) pointsEl.textContent = Math.floor(variant.price / 100);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (currentEl) currentEl.classList.toggle('product-page__price-current--sale', !!onSale);
        if (compareEl) {
          if (onSale) {
            compareEl.textContent = fmt(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }

        this.currentAvailable = !!variant.available;
        if (variant.available) {
          this.addBtn.disabled = false;
          this.addBtnText.textContent = this.addLabel;
        } else {
          this.addBtn.disabled = true;
          this.addBtnText.textContent = this.soldLabel;
        }

        if (variant.featured_image && mayMoveGallery) {
          const matchIndex = this.findImageIndex(variant.featured_image.src);
          if (matchIndex >= 0) {
            this.setImage(matchIndex);
          } else {
            const img = this.mainImageEl.querySelector('img');
            if (img) {
              const src = variant.featured_image.src;
              const sep = src.includes('?') ? '&' : '?';
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.src = `${src}${sep}width=1120`;
              img.alt = variant.featured_image.alt || this.productTitle || '';
            }
          }
        }

        this.updateStockIndicator(variant);
        this.updateSpecialOrder(variant);
        this.updateNotify(variant);
        this.updatePickup(variant.id);
      }

      this.updateOptionAvailability();
      this.syncStickyBar(variant);
    }

    updateStockIndicator(variant) {
      if (!this.stockEl) return;
      const qty = this.stockMap[variant.id];
      // The stock map already encodes the server-side gate (a number is emitted only
      // when inventory is tracked AND quantity is 1..10), so checking the map is sufficient.
      const showLowStock =
        variant.available &&
        typeof qty === 'number' &&
        qty > 0 && qty <= 10;
      if (showLowStock) {
        this.stockEl.textContent = this.lowStockLabel.replace('[count]', qty);
        this.stockEl.hidden = false;
      } else {
        this.stockEl.textContent = '';
        this.stockEl.hidden = true;
      }
    }

    updateSpecialOrder(variant) {
      const isSpecial = !!(variant && variant.special_order);
      if (this.specialOrderEl) this.specialOrderEl.hidden = !isSpecial;
      if (this.specialOrderNoteEl) this.specialOrderNoteEl.hidden = !isSpecial;
    }

    updatePickup(variantId) {
      if (!this.pickupContainer || !variantId || !this.pickupUrl) return;

      // Serve a previously fetched variant instantly.
      if (this.pickupCache[variantId] !== undefined) {
        this.pickupContainer.innerHTML = this.pickupCache[variantId];
        this.pickupContainer.classList.remove('is-loading');
        this.pickupContainer.removeAttribute('aria-busy');
        return;
      }

      // Cancel any in-flight request so an older response can't overwrite a newer one.
      if (this.pickupController) this.pickupController.abort();
      this.pickupController = new AbortController();
      this.pickupContainer.classList.add('is-loading');
      this.pickupContainer.setAttribute('aria-busy', 'true');

      const url = `${this.pickupUrl}?variant=${variantId}&section_id=pickup-availability`;
      fetch(url, { signal: this.pickupController.signal })
        .then((r) => r.text())
        .then((html) => {
          const fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-pickup-content]');
          const markup = fresh ? fresh.outerHTML : '';
          this.pickupCache[variantId] = markup;
          this.pickupContainer.innerHTML = markup;
          this.pickupContainer.classList.remove('is-loading');
          this.pickupContainer.removeAttribute('aria-busy');
        })
        .catch((err) => {
          if (err.name === 'AbortError') return; // superseded by a newer request
          this.pickupContainer.classList.remove('is-loading');
          this.pickupContainer.removeAttribute('aria-busy');
          // Leave the previously rendered widget intact on a network error.
        });
    }

    updateOptionAvailability() {
      if (!this.optionInputs || !this.optionInputs.length) return;
      this.optionInputs.forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        if (isNaN(idx)) return;
        // Deliberately NOT filtered by the current selection. A struck chip means "this
        // value is sold out in every combination", not "sold out with what you picked".
        // Combinations that do not exist are repaired in resolveVariant instead.
        const hasAvailable = this.variants.some((v) => v.available && v.options[idx] === input.value);
        const label = this.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.toggle('variant-btn--unavailable', !hasAvailable);
          let note = label.querySelector('[data-unavail-note]');
          if (!hasAvailable) {
            if (!note) {
              note = document.createElement('span');
              note.className = 'visually-hidden';
              note.setAttribute('data-unavail-note', '');
              label.appendChild(note);
            }
            note.textContent = ' (' + this.unavailableLabel + ')';
          } else if (note) {
            note.textContent = '';
          }
        }
      });
    }

    async onFormSubmit(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      const errorEl = this.querySelector('[data-form-error]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      if (this.statusEl) this.statusEl.textContent = '';

      if (this.addBtn) {
        this.addBtn.disabled = true;
        this.addBtn.classList.add('is-loading');
      }
      if (this.stickyBtn) {
        this.stickyBtn.disabled = true;
        this.stickyBtn.classList.add('is-loading');
      }
      // The form error renders by the main button, which is off screen when the shopper
      // used the sticky bar. Bring it into view in that case so a failed add is not silent.
      const fromStickyBar = !!(this.stickyBtn && e.submitter === this.stickyBtn);
      const showError = () => {
        if (errorEl && fromStickyBar) errorEl.scrollIntoView({ block: 'center' });
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          // Page-cart mode (no drawer) announces here; drawer mode announces
          // via the drawer's own live region (this <main> goes inert on open).
          if (this.statusEl) this.statusEl.textContent = this.addedMessage;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open', { detail: { message: this.addedMessage } }));
        } else {
          const error = await response.json();
          if (errorEl) {
            errorEl.textContent = error.description || error.message || this.addErrorLabel;
            errorEl.hidden = false;
            showError();
          }
        }
      } catch (error) {
        if (errorEl) {
          errorEl.textContent = this.addErrorLabel;
          errorEl.hidden = false;
          showError();
        }
      } finally {
        if (this.addBtn) {
          this.addBtn.classList.remove('is-loading');
          this.addBtn.disabled = !this.currentAvailable;
        }
        if (this.stickyBtn) {
          this.stickyBtn.classList.remove('is-loading');
          this.stickyBtn.disabled = !this.currentAvailable;
        }
      }
    }
  }
  customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  function normalizeSearchQuery(value) {
    return String(value || '').trim().toLocaleLowerCase('en');
  }

  const searchPageForm = document.querySelector('[data-search-page-form]');
  if (searchPageForm) {
    searchPageForm.addEventListener('submit', () => {
      const input = searchPageForm.querySelector('[data-search-page-input]');
      if (!input) return;
      const normalized = normalizeSearchQuery(input.value);
      if (input.value !== normalized) input.value = normalized;
    });
  }

  class SearchFacets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-search-facets-form]');
      this.sort = this.querySelector('[data-search-sort]');

      if (this.form) {
        this.form.addEventListener('change', (e) => {
          if (e.target.matches('input[type="checkbox"]') && !this.isMobile()) this.submit();
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submit();
        });
      }

      if (this.sort) {
        this.sort.addEventListener('change', () => {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', this.sort.value);
          params.delete('page');
          window.location.search = params.toString();
        });
      }
    }

    isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    submit() {
      const data = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of data.entries()) {
        if (v === '') continue;
        params.append(k, k === 'q' ? normalizeSearchQuery(v) : v);
      }
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      window.location.href = `${this.form.getAttribute('action')}?${params.toString()}`;
    }
  }
  if (!customElements.get('search-facets')) {
    customElements.define('search-facets', SearchFacets);
  }

  } catch(e) { console.error(e); }
})();
})();
